export default __webpack_public_path__ + "static/media/se.1c5653cb.svg";